<template>
  <div class="header">
    <div class="logo">
      <svg class="arch" width="220px" height="28px" viewBox="0 0 220 28" xmlns="http://www.w3.org/2000/svg">
        <path transform="scale(0.55)" d="M0.354910444,49.9296324 C0.354910444,49.9296324 74.7825138,0.156265878 201.940858,0.156265878 C329.099203,0.156265878 399.973146,47.948769 399.973146,47.948769 C399.973146,47.948769 325.728811,12.8655647 201.940858,12.8655647 C78.1529056,12.8655647 0.354910444,49.9296324 0.354910444,49.9296324 Z" fill="#3CA0C8"></path>
      </svg>
      <div class="top">
        Northland
      </div>
      <div class="bottom">
        <span v-for="x in 'numerics'">{{ x }}</span>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  name: 'TopBanner',
}
</script>




<style scoped>
.header {
  background: -webkit-radial-gradient(closest-corner, rgba(16, 47, 70, 0) 60%, rgba(16, 47, 70, 0.26)), -webkit-linear-gradient(108deg, #5E8199, #153752 90%);
  font-family: 'PT Sans', Helvetica, Arial, sans-serif;
  display: flex;
  user-select: none;
}
.header:before, .header:after {
  content: "";
  flex: 1 0 0;
}
.logo {
  color: white;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
}
.arch {
  align-self: center;
  margin-bottom: -2px;
}
.top {
  font-size: 70px;
  margin: 0 -2px;
  margin-bottom: -10px;
}
.bottom {
  display: flex;
  justify-content: space-between;
  font-size: 50px;
}
</style>
